/* jshint esversion: 6 */
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ReactSortable } from "react-sortablejs";

import ItemComponent from './item-component';

const { __ } = wp.i18n;

const { ButtonGroup, Dashicon, Tooltip, Popover, Button, SelectControl, FormFileUpload } = wp.components;

const { Component, Fragment } = wp.element;
class ConditionalComponent extends Component {
	constructor() {
		super( ...arguments );
		this.updateValues = this.updateValues.bind( this );
		this.onDragEnd = this.onDragEnd.bind( this );
		this.onDragStart = this.onDragStart.bind( this );
		this.onDragStop = this.onDragStop.bind( this );
		this.removeItem = this.removeItem.bind( this );
		this.saveArrayUpdate = this.saveArrayUpdate.bind( this );
		this.toggleEnableItem = this.toggleEnableItem.bind( this );
		this.onChangeShow = this.onChangeShow.bind( this );
		this.onChangeLabel = this.onChangeLabel.bind( this );
		this.onChangeHide = this.onChangeHide.bind( this );
		this.onChangeUser = this.onChangeUser.bind( this );
		this.onChangeUserHide = this.onChangeUserHide.bind( this );
		this.onChangeEnableExpires = this.onChangeEnableExpires.bind( this );
		this.onChangeExpires = this.onChangeExpires.bind( this );
		this.onChangeAllShow = this.onChangeAllShow.bind( this );
		this.onExport = this.onExport.bind( this );
		this.onImport = this.onImport.bind( this );
		this.onCopyImport = this.onCopyImport.bind( this );
		this.addItem = this.addItem.bind( this );
		let value = this.props.control.setting.get();
		let baseDefault = {
			'items': [
				{
					'id': 'kadence_conditional_header_01',
					'label': 'Extra Header',
					'enabled': false,
					'show': '',
					'all_show': false,
					'hide': '',
					'user': '',
					'user_hide': '',
					'enable_expires': false,
					'expires': '',
				},
			],
		};
		this.defaultValue = this.props.control.params.default ? {
			...baseDefault,
			...this.props.control.params.default
		} : baseDefault;
		value = value ? {
			...this.defaultValue,
			...value
		} : this.defaultValue;
		let defaultParams = {
			'group' : 'conditional_item_group',
			'options': [
				{ value: '', label: __( 'Start Basic', 'kadence-pro' ) },
				{ value: 'copy', label: __( 'Copy Default', 'kadence-pro' ) },
				{ value: 'import', label: __( 'Import', 'kadence-pro' ) },
			],
		};
		this.controlParams = this.props.control.params.input_attrs ? {
			...defaultParams,
			...this.props.control.params.input_attrs,
		} : defaultParams;
		let availableHeaderOptions = [];
		this.controlParams.options.map( ( option ) => {
			if ( ! value.items.some( obj => obj.id === option.value ) ) {
				availableHeaderOptions.push( option );
			}
		} );
		this.state = {
			value: value,
			isVisible: false,
			isProcessing: false,
			control: '',
			upload: false,
			file: '',
		};
	}
	onDragStart() {
		var dropzones = document.querySelectorAll( '.kadence-builder-area' );
		var i;
		for (i = 0; i < dropzones.length; ++i) {
			dropzones[i].classList.add( 'kadence-dragging-dropzones' );
		}
	}
	onDragStop() {
		var dropzones = document.querySelectorAll( '.kadence-builder-area' );
		var i;
		for (i = 0; i < dropzones.length; ++i) {
			dropzones[i].classList.remove( 'kadence-dragging-dropzones' );
		}
	}
	saveArrayUpdate( value, index ) {
		let updateState = this.state.value;
		let items = updateState.items;

		const newItems = items.map( ( item, thisIndex ) => {
			if ( index === thisIndex ) {
				item = { ...item, ...value };
			}

			return item;
		} );
		updateState.items = newItems;
		this.setState( { value: updateState } );
		this.updateValues( updateState );
	}
	toggleEnableItem( value, itemIndex ) {
		this.saveArrayUpdate( { enabled: value }, itemIndex );
	}
	onChangeLabel( value, itemIndex ) {
		this.saveArrayUpdate( { label: value }, itemIndex );
	}
	onChangeShow( value, itemIndex ) {
		this.saveArrayUpdate( { show: value }, itemIndex );
	}
	onChangeHide( value, itemIndex ) {
		this.saveArrayUpdate( { hide: value }, itemIndex );
	}
	onChangeUser( value, itemIndex ) {
		this.saveArrayUpdate( { user: value }, itemIndex );
	}
	onChangeUserHide( value, itemIndex ) {
		this.saveArrayUpdate( { user_hide: value }, itemIndex );
	}
	onChangeEnableExpires( value, itemIndex ) {
		this.saveArrayUpdate( { enable_expires: value }, itemIndex );
	}
	onChangeExpires( value, itemIndex ) {
		this.saveArrayUpdate( { expires: value }, itemIndex );
	}
	onChangeAllShow( value, itemIndex ) {
		this.saveArrayUpdate( { all_show: value }, itemIndex );
	}
	onExport( itemID, itemIndex ) {
		var data = new FormData();
		data.append( 'action', 'kadence_pro_header_export' );
		data.append( 'security', kadenceCustomizerConditionalData.nonce.export );
		data.append( 'header', itemID );
		var control = this;
		jQuery.ajax({
			method:      'POST',
			url:         kadenceCustomizerConditionalData.ajax_url,
			data:        data,
			contentType: false,
			processData: false,
		})
		.done( function( response, status, stately ) {
			console.log( response );
			if ( 'undefined' !== typeof response.data.url ) {
				control.setState( { isVisible: false, isProcessing:false, hasError: false } );
				window.location = response.data.url;
			} else {
				control.setState( { isVisible: false, isProcessing:false, hasError: response.data } );
			}
		})
		.fail( function( error ) {
			console.log( 'error' );
			console.log( error );
			control.setState( { isVisible: false, isProcessing:false, hasError: error.statusText } );
		});
	}
	removeItem( itemID, itemIndex ) {
		var data = new FormData();
		data.append( 'action', 'kadence_pro_header_remove' );
		data.append( 'security', kadenceCustomizerConditionalData.nonce.import );
		data.append( 'header', itemID );
		var control = this;
		jQuery.ajax({
			method:      'POST',
			url:         kadenceCustomizerConditionalData.ajax_url,
			data:        data,
			contentType: false,
			processData: false,
		})
		.done( function( response, status, stately ) {
			console.log( response );
		})
		.fail( function( error ) {
			console.log( 'error' );
			console.log( error );
		});
		let updateState = this.state.value;
		let update = updateState.items;
		let updateItems = [];
		{ update.length > 0 && (
			update.map( ( old, index ) => {
				if ( itemIndex !== index ) {
					updateItems.push( old );
				}
			} )
		) };
		updateState.items = updateItems;
		this.setState( { value: updateState } );
		this.updateValues( updateState );
	}
	addItem() {
		let updateState = this.state.value;
		let update = updateState.items;
		const itemControl = this.state.control;
		let label = __( 'Extra Header', 'kadence-pro' );
		if ( itemControl === 'copy' ) {
			label = __( 'Copy Default Header', 'kadence-pro' );
		}
		let total = update.length;
		total ++;
		let newItem = {
			'id': 'kadence_conditional_header_' + Math.floor( Math.random() * 5000 ),
			'label': label + ' ' + total,
			'enabled': false,
			'show': '',
			'all_show': false,
			'hide': '',
			'user': '',
			'user_hide': '',
			'enable_expires': false,
			'expires': '',
		};
		update.push( newItem );
		updateState.items = update;
		switch ( itemControl ) {
			case 'copy':
				this.onCopyImport( newItem.id, updateState );
				break;
			case 'import':
				this.onImport( newItem.id, this.state.file, updateState );
				break;
			default:
				this.setState( { value: updateState, isVisible: false, control: '' } );
				this.updateValues( updateState );
				break;
		}
	}
	onCopyImport( itemID, updateState ) {
		var data = new FormData();
		data.append( 'action', 'kadence_pro_header_default' );
		data.append( 'security', kadenceCustomizerConditionalData.nonce.import );
		data.append( 'header', itemID );
		var control = this;
		jQuery.ajax({
			method:      'POST',
			url:         kadenceCustomizerConditionalData.ajax_url,
			data:        data,
			contentType: false,
			processData: false,
		})
		.done( function( response, status, stately ) {
			console.log( response );
			if ( 'undefined' !== typeof response.data ) {
				control.setState( { isVisible: false, isProcessing:false, control: '', hasError: response.data } );
			} else {
				control.updateValues( updateState );
				control.setState( { value: updateState, isVisible: false, control: '', isProcessing:false, hasError: false } );
			}
		})
		.fail( function( error ) {
			console.log( 'error' );
			console.log( error );
			control.setState( { isVisible: false, control: '', isProcessing:false, hasError: error.statusText } );
		});
	}
	onImport( itemID, file_data, updateState ) {
		var data = new FormData();
		data.append( 'action', 'kadence_pro_header_import' );
		data.append( 'security', kadenceCustomizerConditionalData.nonce.import );
		data.append( 'header', itemID );
		data.append( 'file', file_data );
		var control = this;
		jQuery.ajax({
			method:      'POST',
			url:         kadenceCustomizerConditionalData.ajax_url,
			data:        data,
			contentType: false,
			processData: false,
		})
		.done( function( response, status, stately ) {
			console.log( 'response' );
			console.log( response );
			if ( 'undefined' !== typeof response.data ) {
				control.setState( { isVisible: false, control: '', isProcessing:false, hasError: response.data } );
			} else {
				control.updateValues( updateState );
				control.setState( { value: updateState, control: '', isVisible: false, isProcessing:false, hasError: false } );
			}
		})
		.fail( function( error ) {
			console.log( 'error' );
			console.log( error );
			control.setState( { isVisible: false, control: '', isProcessing:false, hasError: error.statusText } );
		});
	}
	onDragEnd( items ) {
		let updateState = this.state.value;
		let update = updateState.items;
		let updateItems = [];
		{ items.length > 0 && (
			items.map( ( item ) => {
				update.filter( obj => {
					if ( obj.id === item.id ) {
						updateItems.push( obj );
					}
				} )
			} )
		) };
		if ( ! this.arraysEqual( update, updateItems ) ) {
			update.items = updateItems;
			updateState.items = updateItems;
			this.setState( { value: updateState } );
			this.updateValues( updateState );
		}
	}
	arraysEqual( a, b ) {
		if (a === b) return true;
		if (a == null || b == null) return false;
		if (a.length != b.length) return false;		
		for (var i = 0; i < a.length; ++i) {
			if (a[i] !== b[i]) return false;
		}
		return true;
	}
	render() {
		const currentList = ( typeof this.state.value != "undefined" && this.state.value.items != null && this.state.value.items.length != null && this.state.value.items.length > 0 ? this.state.value.items : [] );
		let theItems = [];
		{ currentList.length > 0 && (
			currentList.map( ( item ) => {
				theItems.push(
					{
						id: item.id,
					}
				)
			} )
		) };
		const availableHeaderOptions = [];
		this.controlParams.options.map( ( option ) => {
			if ( ! theItems.some( obj => obj.id === option.value ) ) {
				availableHeaderOptions.push( option );
			}
		} );
		const toggleClose = () => {
			if ( this.state.isVisible === true ) {
				this.setState( { isVisible: false, control: '' } );
			}
		};
		return (
			<div className="kadence-control-field kadence-sorter-items">
				<div className="kadence-sorter-row">
					<ReactSortable animation={100} onStart={ () => this.onDragStop() } onEnd={ () => this.onDragStop() } group={ this.controlParams.group } className={ `kadence-sorter-drop kadence-sorter-sortable-panel kadence-sorter-drop-${ this.controlParams.group }` } handle={ '.kadence-sorter-item-panel-header' } list={ theItems } setList={ ( newState ) => this.onDragEnd( newState ) } >
						{ currentList.length > 0 && (
							currentList.map( ( item, index ) => {
								return <ItemComponent removeItem={ ( itemID, remove ) => this.removeItem( itemID, remove ) } toggleEnabled={ ( enable, itemIndex ) => this.toggleEnableItem( enable, itemIndex ) } onChangeLabel={ ( label, itemIndex ) => this.onChangeLabel( label, itemIndex ) } onChangeAllShow={ ( all_show, itemIndex ) => this.onChangeAllShow( all_show, itemIndex ) } onChangeEnableExpires={ ( enable_expires, itemIndex ) => this.onChangeEnableExpires( enable_expires, itemIndex ) } onChangeHide={ ( hide, itemIndex ) => this.onChangeHide( hide, itemIndex ) } onChangeUser={ ( user, itemIndex ) => this.onChangeUser( user, itemIndex ) } onChangeUserHide={ ( user_hide, itemIndex ) => this.onChangeUserHide( user_hide, itemIndex ) } onChangeShow={ ( show, itemIndex ) => this.onChangeShow( show, itemIndex ) } onChangeExpires={ ( expires, itemIndex ) => this.onChangeExpires( expires, itemIndex ) } onExport={ ( itemID, itemIndex ) => this.onExport( itemID, itemIndex ) } key={ item.id } index={ index } item={ item } controlParams={ this.controlParams } />;
							} )
						) }
					</ReactSortable>
				</div>
				{ this.state.hasError && (
					<div class="import-has-errors">
						{ this.state.hasError }
					</div>
				) }
				<div className="kadence-headers-add-area">
					{ this.state.isVisible && (
						<Popover position="top right" className="kadence-popover-color kadence-popover-social" onClose={ toggleClose }>
							<div className="kadence-popover-add-heading-list">
								{ this.state.upload && (
									<div className="kadence-import-header-form">
										<div className="kadence-components-form-file-upload">
											<input
												type="file"
												multiple={ false }
												onChange={ ( event ) => {
													if ( event.target.files[0] ) {
														this.setState( { file: event.target.files[0] } );
													}
												} }
											/>
										</div>
										<Button
											isPrimary
											disabled={ this.state.file ? false : true }
											className={ 'conditional-add-btn' }
											onClick={ () => {
													this.addItem();
											} }
										>
												{ __( 'Import and Create New', 'kadence-pro' ) }
										</Button>
									</div>
								) }
								{ ! this.state.upload && (
									<ButtonGroup className="kadence-radio-container-control">
										{ availableHeaderOptions.map( ( item, index ) => {
											return (
												<Fragment>
													<Button
														isTertiary
														className={ 'conditional-add-radio-btn' }
														onClick={ () => {
															this.setState( { control: availableHeaderOptions[index].value } );
															this.state.control = availableHeaderOptions[index].value;
															if ( 'import' === availableHeaderOptions[index].value ) {
																this.setState( { upload: true } );
															} else {
																this.addItem();
															}
														} }
													>
														{ availableHeaderOptions[index].label && (
															availableHeaderOptions[index].label
														) }
													</Button>
												</Fragment>
											);
										} ) }
									</ButtonGroup>
								) }
							</div>
						</Popover>
					) }
					<Button
						className="kadence-sorter-add-item"
						isPrimary
						onClick={ () => {
							this.setState( { isVisible: true } );
						} }
					>
						{ __( 'Add Header', 'kadence-pro' ) }
						<Dashicon icon="plus"/>
					</Button>
					{/* <Button
						className="kadence-sorter-add-item"
						isPrimary
						onClick={ () => {
							this.addItem();
						} }
					>
						{ __( 'Add Item', 'kadence-pro' ) }
						<Dashicon icon="plus"/>
					</Button> */}
				</div>
			</div>
		);
	}
	updateValues( value ) {
		this.props.control.setting.set( {
			...this.props.control.setting.get(),
			...value,
			flag: !this.props.control.setting.get().flag
		} );
		let event = new CustomEvent(
			'kadenceUpdateConditional', {
				'detail': 'conditional_header'
			} );
		document.dispatchEvent( event );
	}
}

ConditionalComponent.propTypes = {
	control: PropTypes.object.isRequired,
};

export default ConditionalComponent;
